var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.item.nodes && _vm.item.nodes.length
    ? _c(
        "el-submenu",
        { attrs: { index: _vm.navIndex } },
        [
          _c("template", { slot: "title" }, [
            _vm.item.icon ? _c("i", { staticClass: "item.icon" }) : _vm._e(),
            _vm._v(_vm._s(_vm.item.name))
          ]),
          _vm._v(" "),
          _vm._l(_vm.item.nodes, function(subItem, i) {
            return _c("nav-bar-item", {
              key: _vm.navIndex + "-" + i,
              attrs: { navIndex: _vm.navIndex + "-" + i, item: subItem }
            })
          })
        ],
        2
      )
    : _c(
        "el-menu-item",
        {
          attrs: {
            index: _vm.item.action,
            route: { path: "/" + _vm.item.action }
          }
        },
        [
          _vm.item.icon ? _c("i", { staticClass: "item.icon" }) : _vm._e(),
          _vm._v(_vm._s(_vm.item.name))
        ]
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15d45251", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15d45251","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/components/SidebarItem.vue
// module id = null
// module chunks = 